import Swal from 'sweetalert2';

import { func_validation } from "functions";

export function LoadingToaster(props) {
    const { type, msg, position, isTimerProgressBarHidden } = props;

    // Validate Props
    let type_formatted = "";
    if (func_validation.isStringTrimNotEmpty(type)) type_formatted = type;
    let msg_formatted = "Downloading...";
    if (func_validation.isStringTrimNotEmpty(msg)) msg_formatted = msg;
    let position_formatted = "top-end";
    if (func_validation.isStringTrimNotEmpty(position)) position_formatted = position;

    const toaster = Swal.mixin({
        toast: true,
        position: position_formatted,
        showConfirmButton: false,
        timerProgressBar: !isTimerProgressBarHidden,
        didOpen: () => {
            Swal.showLoading();
        }
    });
      
    toaster.fire({
        icon: type_formatted,
        title: msg_formatted,
    });

    return toaster;
}